var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._ssrNode(((_vm.showImg)?("<div"+(_vm._ssrClass(null,_vm.prefixCls + '__img'))+"><img"+(_vm._ssrAttr("src",_vm.imgUrl))+" alt></div>"):"<!---->")+" <p"+(_vm._ssrClass(null,_vm.prefixCls + '__desc'))+">"+_vm._ssrEscape(_vm._s(_vm.desc))+"</p> "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0124f93c","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/empty/empty.vue
// module id = 800
// module chunks = 0 1 55